import React from "react";
import { Carousel } from "react-bootstrap";
import { banner, banner2, banner3, banner4 } from "../../Assets.tsx";
import 'bootstrap/dist/css/bootstrap.min.css'; 
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const BannerCarousel = () => {
  useGSAP(() => {
    gsap.from(".gsapRightSideNavCarosel", {
      y: -30,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      delay: 1,
    });
  });

  return (
    <Carousel
    fade={true}
    interval={3000}
    className="gsapRightSideNavCarosel"
    nextIcon={null}  
    prevIcon={null} 
    indicators={false}
>
  <Carousel.Item style={{height:"700px",display:"flex",alignItems:"center",justifyContent:"center" }} className="fullWidthBanner" >
        <img className="d-block w-100 fullWidthBanner" src={banner} alt="Third slide"  />
        <Carousel.Caption
          style={{
            position: "absolute",
            bottom: "20px",
            left: 0,
            right: 0,
            textAlign: "center",
            color: "white",
          }}
          className="gsapBannerImageCarousel"
        >
          <h3 style={{color: "black"}}>Kamdhenu Park</h3>
        </Carousel.Caption>
      </Carousel.Item>
      {/* <Carousel.Item style={{height:"700px",display:"flex",alignItems:"center",justifyContent:"center" }} className="fullWidthBanner" >
        <img className="d-block w-100 fullWidthBanner" src={banner3} alt="Third slide" />
        <Carousel.Caption
          style={{
            position: "absolute",
            bottom: "20px",
            left: 0,
            right: 0,
            textAlign: "center",
            color: "white",
          }}
          className="gsapBannerImageCarousel"
        >
              <h3 style={{color: "black"}}>Kamdhenu Park</h3>
         
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item style={{height:"700px",display:"flex",alignItems:"center",justifyContent:"center" }} className="fullWidthBanner" >
        <img className="d-block w-100 fullWidthBanner"src={banner2} alt="Third slide" />
        <Carousel.Caption
          style={{
            position: "absolute",
            bottom: "20px",
            left: 0,
            right: 0,
            textAlign: "center",
            color: "white",
          }}
          className="gsapBannerImageCarousel"
        >
              <h3 style={{color: "black"}}>Kamdhenu Park</h3>
         
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item style={{height:"700px",display:"flex",alignItems:"center",justifyContent:"center" }} className="fullWidthBanner" >
        <img className="d-block w-100 fullWidthBanner" src={banner4} alt="Third slide" />
        <Carousel.Caption
          style={{
            position: "absolute",
            bottom: "20px",
            left: 0,
            right: 0,
            textAlign: "center",
            color: "white",
          }}
          className="gsapBannerImageCarousel"
        >
              <h3 style={{color: "black"}}>Kamdhenu Park</h3>
         
        </Carousel.Caption>
      </Carousel.Item> */}
    </Carousel>
  );
};

export default BannerCarousel;
